import React from 'react';
import SpaceRoleRangeForm from './SpaceRoleRangeForm';

function SpaceSettingTaskFeedbackForm(props) {
  return (
    <SpaceRoleRangeForm
      {...props}
      role="task_feedback"
      settingKey="task_feedback_role_setting"
      defaultRange="admin"
    />
  );
}

export default SpaceSettingTaskFeedbackForm;
